import NotificationList from "@/components/notifications/NotificationList";
import { studentNotificationService } from "@/services/notificationService";

export default function StudentNotifications() {
  return <NotificationList title="Notifications" service={studentNotificationService} testId="student-notifications-list" />;
}
